import { Button } from "primereact/button";
import { Route } from 'react-router-dom'
import { Dialog } from 'primereact/dialog';

import "../DialogConcordanciaParticipar/style.css"

const DialogConcordanciaParticipar = (props) => { //Renderiza modal para aceite das condições e início do questionário.
    const dialogName = 'startResponder';
        const footer = (
            <div className="p-d-flex p-jc-between p-mt-3">
                <Route render={(props2) => (
                    <Button className="p-button-danger" label="DISCORDO" icon="pi pi-times" onClick={() => {
                        props.alterarEstado();
                        props.alterarEtapa();
                        props2.history.goBack();
                    }} />
                )} />

                <Button label="CONCORDO" icon="pi pi-check" onClick={() => {
                    props.alterarEstado();
                    
                }} />
            </div>
        );


        return (
            <Dialog className= "dialog-box" closable={false} header="Você deseja confirmar a sua participação?" footer={footer} visible={props.estado[dialogName]} modal onHide={() => this.onHide(dialogName)} >
                <ol >
                    <li>As respostas são armazenadas sem identificá-lo, preservando o seu anonimato.<br /></li>
                    <li>Ao prosseguir com este questionário você concorda em participar do processo avaliativo.<br /></li>
                    <li>O questionário não poderá mais ser modificado depois de enviado.<br /></li>
                    <li>Passe por cada etapa do questionário usando os botões no início da tela para
                        <span className= "dialog-box-name-green">  AVANÇAR (verde)</span> ou <span className= "dialog-box-name-red">RETROCEDER (vermelho)</span> etapas do questionário.</li>
                </ol>
            </Dialog>
        );

};
export default DialogConcordanciaParticipar;

//style={{ width: '85vw' }}
//style={{ lineHeight: '1.25rem', listStylePosition: 'inside', display: 'flex', flexDirection: 'column' }}
// style={{ 'color': 'var(--green-500)' }}
//style={{ 'color': 'var(--pink-500)' }}